import { render, staticRenderFns } from "./InvestorProfileRootPage.vue?vue&type=template&id=b4abbbbc&"
import script from "./InvestorProfileRootPage.vue?vue&type=script&lang=js&"
export * from "./InvestorProfileRootPage.vue?vue&type=script&lang=js&"
import style0 from "./InvestorProfileRootPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports